import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import { Icon } from './styles';

const AppsItem = props => {
    const { suggestion } = props

    return (
        <ListItem button onClick={() => props.handleSelected(suggestion)}>
            <Icon alt="icon" src={suggestion.icon} />
            <div>
                <Typography>{suggestion.title}</Typography>
                <Typography variant="body2">{suggestion.summary}</Typography>
            </div>
        </ListItem>
    );
}

AppsItem.propTypes = {
    suggestion: PropTypes.object.isRequired
}

export default AppsItem